/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Luci_Shopping_Api_Models_CustomerContactInfo } from './Luci_Shopping_Api_Models_CustomerContactInfo';
import type { Luci_Shopping_Api_Models_Image } from './Luci_Shopping_Api_Models_Image';
import type { Luci_Shopping_Api_Models_MyStory } from './Luci_Shopping_Api_Models_MyStory';
import type { Luci_Shopping_Api_Models_PickupPolicy } from './Luci_Shopping_Api_Models_PickupPolicy';
import type { Luci_Shopping_Api_Models_ReturnPolicy } from './Luci_Shopping_Api_Models_ReturnPolicy';
import type { Luci_Shopping_Api_Models_ShippingPolicy } from './Luci_Shopping_Api_Models_ShippingPolicy';
import type { Luci_Shopping_Api_Models_ShippingRules } from './Luci_Shopping_Api_Models_ShippingRules';
import type { Luci_Shopping_Api_Models_StoreExternalLinkSettings } from './Luci_Shopping_Api_Models_StoreExternalLinkSettings';
import type { Luci_Shopping_Api_Models_Tenant } from './Luci_Shopping_Api_Models_Tenant';
export type Luci_Shopping_Api_Models_Store = {
  id?: number;
  storeName?: string;
  webAlias?: string;
  cartExpirationDurationInMinutes?: number;
  emailAddress?: string;
  phoneNumber?: string;
  dba?: string;
  ownerName?: string;
  biography?: string;
  facebookAccount?: string;
  twitterAccount?: string;
  pinterestAccount?: string;
  instagramAccount?: string;
  isStoreCustomerRewardsEnabled?: boolean;
  externalLinks?: Array<Luci_Shopping_Api_Models_StoreExternalLinkSettings>;
  youtubeAccount?: string;
  myStory?: Luci_Shopping_Api_Models_MyStory;
  shippingPolicy?: Luci_Shopping_Api_Models_ShippingPolicy;
  returnPolicy?: Luci_Shopping_Api_Models_ReturnPolicy;
  pickupPolicy?: Luci_Shopping_Api_Models_PickupPolicy;
  emailSignature?: string;
  hasFreeShippingRule?: boolean;
  minimumOrderTotalToEarnFreeShipping?: number;
  bioImage?: Luci_Shopping_Api_Models_Image;
  tenant?: Luci_Shopping_Api_Models_Tenant;
  shippingRules?: Luci_Shopping_Api_Models_ShippingRules;
  shoppingPortalEnabled?: boolean;
  isSuspended?: boolean;
  customerContactInfo?: Luci_Shopping_Api_Models_CustomerContactInfo;
  paymentProcessors?: Array<'Cash' | 'FirstAmerican' | 'ProPay' | 'ProPayApplication' | 'PayPal' | 'Fake'>;
  byDesignRepDID?: string;
  /**
   * How the store charges taxes for online orders.
   */
  taxStrategy?: Luci_Shopping_Api_Models_Store.taxStrategy;
  payPalEnabled?: boolean;
  merchantId?: string;
};
export namespace Luci_Shopping_Api_Models_Store {
  /**
   * How the store charges taxes for online orders.
   */
  export enum taxStrategy {
    NONE = 'None',
    CHARGE_TAX = 'ChargeTax',
    TAX_REIMBURSEMENT = 'TaxReimbursement',
  }
}

